import React, { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { TableAppReleases } from './components/TableAppReleases';
import { BannerInfoNovedades } from './components/BannerInfoNovedades';
import { PageLayout } from 'components/generics/PageLayout';
import { hasPemissions } from 'commons/utils';

export const NovedadesRelease = () => {
  const navigate = useNavigate();
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedRelease, setSelectedRelease] = useState(null);

  const handleOpenCreate = () => navigate('/manager/novedades/crear');


  const [canCreate, setCanCreate] = useState(false);

  useEffect(() => {
    canCheckCanCreate();
  }, []);

  const canCheckCanCreate = async () => {
    const havePermissions = await hasPemissions('modulo.manager', 'modulo.manager.novedades', 'create');
    setCanCreate(havePermissions);
  };

  return (
    <PageLayout
        title="Gestión de Novedades (Releases)"
        mainModule="Manager"
        icon="NewReleases"
        infoAlert="Controla las versiones y características liberadas en cada aplicación"
        actionButtons={
            canCreate && (
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={handleOpenCreate}
                >
                  Nueva Novedad
                </Button>
            )
        }
    >
      <Box sx={{ pt: 3 }}>

        <TableAppReleases />
        
        <BannerInfoNovedades />
      </Box>
    </PageLayout>
  );
};
